export default function() {
  function accordion_toggle() {

    const acc = Array.from(document.getElementsByClassName('accordion__button'))
    const activeClass = 'active'

    acc.forEach(function(item) {
      item.addEventListener('click', function() {
        if (this.classList.contains(activeClass)) {
          this.classList.remove(activeClass)
        } else {
          acc.forEach(function(acc) { acc.classList.remove(activeClass) })
          this.classList.add(activeClass)
        }
      })
    })
  }
  accordion_toggle()
}